import { AppBar as BaseAppBar, Box, Divider, Toolbar } from "@mui/material";
import UserMenu from "./userMenu/UserMenu";
import useAuthValue from "../modules/authModule/hooks/useAuthValue";
import Images from "../assets/Images";
import HospitalSelector from "../modules/hospitalModule/components/HospitalSelector/HospitalSelector";
import SuperUserHospitalSelector from "../modules/hospitalModule/components/HospitalSelector/SuperUserHospitalSelector";

const NotLoggedInAppBar = () => (
  <BaseAppBar sx={{ bgcolor: "custom.background.brand" }}>
    <Toolbar sx={{ justifyContent: "space-between" }}>
      <img src={Images.OrvaLogo} alt="Logo" width="172px" height="24px" />
    </Toolbar>
  </BaseAppBar>
);

const LoggedInAppBar = () => {
  const { user } = useAuthValue();
  const isSuperUser = user?.isSuperUser;

  return (
    <BaseAppBar
      sx={{
        bgcolor: "custom.background.brand",
      }}
    >
      <Toolbar
        sx={{
          justifyContent: "space-between",
          px: { xs: 2, sm: 2 },
        }}
      >
        <img src={Images.OrvaLogo} alt="" width="172px" height="24px" />
        <Box
          display="flex"
          alignItems="center"
          px={1}
          border={!isSuperUser ? "none" : "1px solid #FFFFFF80"}
          borderRadius={10}
        >
          {!isSuperUser ? (
            <>
              <HospitalSelector />
              <Divider
                orientation="vertical"
                sx={{
                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                  width: "1px",
                  height: "30px",
                  marginLeft: 1,
                }}
              />
            </>
          ) : (
            <SuperUserHospitalSelector />
          )}
          <UserMenu />
        </Box>
      </Toolbar>
    </BaseAppBar>
  );
};

const AppBar = () => {
  const { isLoggedIn } = useAuthValue();
  return isLoggedIn ? <LoggedInAppBar /> : <NotLoggedInAppBar />;
};

export default AppBar;
